<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="tw-w-full text-right">
            <a
                :href="
                    `/backend/s/${shop}/salepages/${salePage.id}/bodies/create`
                "
            >
                <button type="button" class="btn btn-sm btn-dark">
                    <i class="fa fa-plus mr-2"></i>
                    เพิ่มข้อมูล
                </button>
            </a>
        </div>
        <div class="list list-group tw-cursor-pointer">
            <sortable
                v-for="(item, index) in salePageBodies"
                v-model="dragData"
                :key="index"
                :index="index"
                drag-direction="vertical"
                replace-direction="vertical"
                class="list-group-item px-0"
                @sortend="sortend($event, salePageBodies)"
                @real-click="click"
            >
                <div class="card card-salepage-body">
                    <div
                        class="card-header card-header-body"
                        v-if="item.type === 'text'"
                    >
                        ประเภทข้อความ
                    </div>
                    <div
                        class="card-header card-header-body"
                        v-if="item.type === 'image'"
                    >
                        ประเภทรูปภาพ
                    </div>
                    <div
                        class="card-header card-header-body"
                        v-if="item.type === 'video'"
                    >
                        ประเภทวิดีโอ
                    </div>
                    <div
                        class="card-header card-header-body"
                        v-if="item.type === 'button'"
                    >
                        ประเภท Call to action
                    </div>
                    <div
                        class="card-header card-header-body"
                        v-if="item.type === 'slider'"
                    >
                        ประเภทสไลด์
                    </div>
                    <div
                        class="card-header card-header-body"
                        v-if="item.type === 'linktree'"
                    >
                        ประเภท linktree
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-9 col-sm-12">
                                <div class="custom-salepage">
                                    <div
                                        class="custom-salepage__linktree tw-overflow-scroll"
                                        v-if="item.type == 'linktree'"
                                    >
                                        <div class="">
                                            <a
                                                :href="
                                                    `/backend/s/${shop}/salepages/${salePage.id}/bodies/${item.id}/edit`
                                                "
                                            >
                                                <button
                                                    class="btn btn-success tw-font-bold"
                                                >
                                                    ดูรายละเอียด linktree
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                    <div
                                        class="custom-salepage__text tw-overflow-scroll"
                                        v-if="item.type == 'text'"
                                    >
                                        <div
                                            class="tw-pointer-events-none"
                                            v-html="item.body"
                                        ></div>
                                    </div>
                                    <div
                                        class="custom-salepage__image"
                                        v-else-if="item.type == 'image'"
                                    >
                                        <img :src="item.image_url" alt="" />
                                    </div>
                                    <div
                                        class="custom-salepage__video tw-pointer-events-none"
                                        v-else-if="item.type == 'video'"
                                    >
                                        <iframe
                                            :src="item.body"
                                            title="YouTube video player"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen
                                        ></iframe>
                                    </div>
                                    <div
                                        class="custom-salepage__button"
                                        v-else-if="item.type == 'button'"
                                    >
                                        <a :href="item.url" class="isDisabled">
                                            <img :src="item.image_url" />
                                        </a>
                                    </div>
                                    <div
                                        class="custom-salepage__slider"
                                        v-else-if="item.type == 'slider'"
                                    >
                                        <div
                                            :id="
                                                `carouselExampleControls-${item.id}`
                                            "
                                            class="carousel slide"
                                            data-ride="carousel"
                                        >
                                            <div class="carousel-inner">
                                                <div
                                                    class="carousel-item"
                                                    v-for="(i,
                                                    index) in item.slides"
                                                    :key="index"
                                                    :class="{
                                                        active: index == 0
                                                    }"
                                                >
                                                    <img
                                                        class="d-block w-100"
                                                        :src="i.image_url"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <a
                                                class="carousel-control-prev"
                                                :href="
                                                    `#carouselExampleControls-${item.id}`
                                                "
                                                role="button"
                                                data-slide="prev"
                                            >
                                                <span
                                                    class="carousel-control-prev-icon"
                                                    aria-hidden="true"
                                                ></span>
                                                <span class="sr-only"
                                                    >Previous</span
                                                >
                                            </a>
                                            <a
                                                class="carousel-control-next"
                                                :href="
                                                    `#carouselExampleControls-${item.id}`
                                                "
                                                role="button"
                                                data-slide="next"
                                            >
                                                <span
                                                    class="carousel-control-next-icon"
                                                    aria-hidden="true"
                                                ></span>
                                                <span class="sr-only"
                                                    >Next</span
                                                >
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-sm-12">
                                <div
                                    class="tw-flex tw-justify-end tw-items-start tw-flex-wrap btn-custom"
                                >
                                    <div>
                                        <a
                                            :href="
                                                `/backend/s/${shop}/salepages/${salePage.id}/bodies/${item.id}/edit`
                                            "
                                        >
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-warning btn-custom__item"
                                            >
                                                <i class="fa fa-edit"> แก้ไข</i>
                                            </button>
                                        </a>
                                    </div>
                                    <button
                                        type="button"
                                        data-type="confirm"
                                        class="btn btn-sm btn-danger js-sweetalert "
                                        title="Delete"
                                        @click="confirmDelete(item.id)"
                                    >
                                        <i class="fa fa-trash-o"> ลบ</i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </sortable>
        </div>
    </div>
</template>

<style scoped>
.isDisabled {
    pointer-events: none;
}
</style>

<script>
export default {
    props: {
        shop: {
            required: true,
            type: String
        },
        salePage: {
            required: true,
            type: Object
        },
    },
    data() {
        return {
            loading: false,
            dragData: {},
            salePageBodies: []
        };
    },
    mounted() {
        this.getSalePageBodies();
    },
    methods: {
        getSalePageBodies() {
            axios
                .get(
                    `/backend/s/${this.shop}/salepages/${this.salePage.id}/bodies`
                )
                .then(res => {
                    this.salePageBodies = res.data;
                    this.changeOrderBySalePageBody(this.salePageBodies);
                });
        },
        async changeOrderBySalePageBody(list) {
            const url = `/ajax/s/${this.shop}/salepages/bodies/${this.salePage.id}/change_order`;
            await axios.post(url, list);
        },
        confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบข้อมูลส่วนนี้ใช่ไหม?",
                text: "เมื่อกดยืนยัน ข้อมูลส่วนนี้จะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            })
                .then(result => {
                    if (result.isConfirmed) {
                        this.deleteSalePageBodie(id);
                    }
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        "ไม่สามารถทำรายการได้กรุณาลองใหม่อีกครั้ง"
                    );
                });
        },
        async deleteSalePageBodie(id) {
            this.loading = true;
            const url = `/ajax/s/${this.shop}/salepages/bodies/${this.salePage.id}/${id}`;
            axios
                .delete(url)
                .then(res => {
                    if (res.data.status == "success") {
                        this.getSalePageBodies();
                        this.loading = false;
                    }
                })
                .catch(err => {});
        },
        click(e) {
            // console.log(e);
            // Todo
        },
        sort(e) {
            const { oldIndex, newIndex } = e;
            // console.log(oldIndex, newIndex);
        },
        sortend(e, list) {
            const { oldIndex, newIndex } = e;
            this.rearrange(list, oldIndex, newIndex);
            this.changeOrderBySalePageBody(list);
        },
        rearrange(array, oldIndex, newIndex) {
            if (oldIndex > newIndex) {
                array.splice(newIndex, 0, array[oldIndex]);
                array.splice(oldIndex + 1, 1);
            } else {
                array.splice(newIndex + 1, 0, array[oldIndex]);
                array.splice(oldIndex, 1);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.card {
    margin-bottom: 0;
    &-body {
        height: 200px;
        @media (min-width: 0px) and (max-width: 992px) {
            height: auto;
        }
        div {
            height: 100%;
            @media (min-width: 0px) and (max-width: 992px) {
                height: auto;
            }
        }
    }
}

.btn-custom {
    height: 100%;
    border-left: 1px solid #eee;
    @media (min-width: 0px) and (max-width: 992px) {
        margin-top: 20px;
        justify-content: center;
        border: none;
    }
    &__item {
        flex: 1;
        margin: 0 2px;
    }
}
.custom-salepage {
    &__text {
        div {
            @media (min-width: 0px) and (max-width: 992px) {
                max-height: 180px;
            }
        }
    }
    &__image {
        max-height: 200px;
        img {
            @media (min-width: 0px) and (max-width: 992px) {
                width: 100%;
                height: auto;
                max-height: 200px;
                object-fit: contain;
                max-width: -webkit-fill-available;
            }
            height: 100%;
            max-width: -webkit-fill-available;
        }
    }
    &__slider {
        // width: 55%;
        width: 100%;
        background: #c3c3c2;
        img {
            height: 175px;
            object-fit: contain;
        }
    }

    &__video {
        max-height: 400px;
        @media (min-width: 0px) and (max-width: 992px) {
            text-align: center;
        }
        iframe {
            @media (min-width: 0px) and (max-width: 992px) {
                width: 100%;
                height: auto;
                max-height: 200px;
                max-width: 300px;
                object-fit: contain;
            }
            height: 100%;
        }
    }
    &__button {
        max-height: 200px;
        a img {
            @media (min-width: 0px) and (max-width: 992px) {
                width: 100%;
                height: auto;
                max-height: 200px;
                object-fit: contain;
                max-width: -webkit-fill-available;
            }
            height: 100%;
            max-width: -webkit-fill-available;
        }
    }
}
.list {
    position: relative;
    margin-top: 20px;
}
.list-group-item {
    border: none;
    margin-bottom: 5px;
    padding: 0;
    @media (min-width: 0px) and (max-width: 992px) {
        padding: 0;
    }
}
.list > *.dragging {
    box-shadow: 0 2px 10px 0 #fed736;
    width: 100%;
}
</style>
